<!-- -------------------------------------------------------------- -->
<!-- confirm delete dialog -->
<!-- -------------------------------------------------------------- -->
 
<mat-dialog-content>Are you sure you want to delete ?</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button class="bg-error text-white" mat-dialog-close mat-dialog-close="true">Yes</button>
  <button mat-flat-button mat-dialog-close mat-dialog-close="false">No</button>
</mat-dialog-actions>
